import { render, staticRenderFns } from "./templatetable.vue?vue&type=template&id=9715b800&scoped=true&"
import script from "./templatetable.vue?vue&type=script&lang=js&"
export * from "./templatetable.vue?vue&type=script&lang=js&"
import style0 from "./templatetable.vue?vue&type=style&index=0&id=9715b800&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9715b800",
  null
  
)

export default component.exports